<template>
    <div>
        <van-popup
                v-model="show_robot_sku_list_model"
                style="min-height: 100%"
                :round="false"
                position="bottom"
                @close="selectListClose"
        >
            <div style="text-align: center; padding: 10px 0px">
                <span style="font-size: 16px">助理清单({{all_sku_list.length}})</span>
                <van-icon name="close" size="22" color="#EE0A24" @click="clickCloseIcon"
                          style="position: absolute; right: 15px; margin-top: 2px"
                />
            </div>
            <van-divider style="margin-top: 0px; margin-bottom: 0px; border-color: #dddddd"/>
            <van-tabs title-active-color="#ee0a24" animated swipeable>
                <van-tab>
                    <div slot="title"><h3>未推送({{sku_list_no_pushed.length}})</h3></div>
<!--                    <van-cell center >-->
<!--                        <span slot="title" style="font-size: 17px">助理发品开关</span>-->
<!--                        <van-switch v-model="switch_checked" slot="right-icon" active-color="#07c160" @change="changeSwitch"/>-->
<!--                    </van-cell>-->

<!--                    <van-row>-->
<!--                        <van-col span="20">-->
<!--                            <span style="font-size: 17px">助理发品开关</span>-->
<!--                        </van-col>-->
<!--                        <van-col span="4">-->
<!--                            <van-switch v-model="switch_checked"  active-color="#07c160"/>-->
<!--                        </van-col>-->
<!--                    </van-row>-->
                    <div>
<!--                        <div>-->
<!--                            <Row type="flex" justify="start" style="padding: 10px;">-->
<!--                                <i-col span="19">-->
<!--                                </i-col>-->
<!--                                <i-col span="5" style="text-align: center">-->
<!--                                    <van-button-->
<!--                                            size="small"-->
<!--                                            type="danger"-->
<!--                                            @click="removeAllSelectSku"-->
<!--                                    >全部移出-->
<!--                                    </van-button>-->
<!--                                </i-col>-->
<!--                            </Row>-->
<!--                        </div>-->
                        <div v-for="(item, index) in sku_list_no_pushed" v-bind:key="index">
                            <Row type="flex" justify="start" style="padding: 10px;">
                                <i-col span="6" style="height: 60px; line-height: 60px; text-align: center">
                                    <Wp_image :url="item.sku_img"></Wp_image>
                                    <!--                                <div>{{item.skuId}}</div>-->
                                </i-col>
                                <i-col span="18">
                                    <div class="select_skuName_div">{{item.sku_name}}</div>
                                    <div style="text-align: right; margin: 3px 10px 0px 0px">
                                        <van-tag size="medium" type="warning">预计今日 {{item.send_time}} 推送</van-tag>
                                    </div>

                                    <div style="text-align: right; margin: 8px 10px 0px 0px">
                                        <van-button
                                                size="small"
                                                type="danger"
                                                @click="removeSelectSku(index)"
                                        >移出助理
                                        </van-button>
                                    </div>

                                </i-col>
<!--                                <i-col span="5" style="height: 60px; line-height: 60px; text-align: center">-->
<!--                                    <van-button-->
<!--                                            size="small"-->
<!--                                            type="danger"-->
<!--                                            @click="removeSelectSku(index)"-->
<!--                                    >移出助理-->
<!--                                    </van-button>-->
<!--                                </i-col>-->
                            </Row>
                            <Divider dashed
                                     style="background-color: #EE0A24;padding-left: 10px;padding-right: 10px; margin-top: 5px; margin-bottom: 5px"></Divider>
                        </div>
                    </div>
                </van-tab>
                <van-tab>
                    <div slot="title"><h3>已推送({{sku_list_pushed.length}})</h3></div>
                    <div v-for="(item, index) in sku_list_pushed" v-bind:key="index">
                        <Row type="flex" justify="start" style="padding: 10px;">
                            <i-col span="5" style="height: 60px; line-height: 60px; text-align: center">
                                <Wp_image :url="item.sku_img"></Wp_image>
                                <!--                                <div>{{item.skuId}}</div>-->
                            </i-col>
                            <i-col span="19">
                                <div class="select_skuName_div">{{item.sku_name}}</div>
                                <div style="text-align: right; margin: 10px 10px 0px 0px">
                                    <van-tag size="medium" type="primary">今日 {{item.send_time}} 已推送</van-tag>
                                </div>
                            </i-col>
                        </Row>

                        <Divider dashed
                                 style="background-color: #EE0A24;padding-left: 10px;padding-right: 10px; margin-top: 15px; margin-bottom: 15px"></Divider>
                    </div>
                </van-tab>
            </van-tabs>
        </van-popup>

    </div>
</template>

<script>
    import Vue from 'vue';
    import {Row, Col, Alert} from 'iview';
    import Wp_image from "./Wp_image";
    import {Dialog, Toast} from "vant";

    Vue.component('Row', Row);
    Vue.component('i-col', Col);
    Vue.component('Alert', Alert);

    export default {
        name: "Wp_join_robot_list_Sheet",
        components: {Wp_image},
        inject: ['WpJoinRobotListMark'],

        data() {
            return {
                //选品清单sheet是否弹出
                show_robot_sku_list_model: false,

                all_sku_list: [],
                sku_list_no_pushed: [],
                sku_list_pushed: [],
                //缓存未推送数据个数，用于判断是否有删除操作
                // temp_sku_list_no_pushed_length: -1,

                switch_checked: true,
            }
        },

        created() {
            // this.initAllRobotSkuList();
        },

        methods: {

            showRobotSkuSheet(){
                this.show_robot_sku_list_model = true;
                // this.getRobotList();
                this.initAllRobotSkuList();
            },

            /**
             * 获取机器人列表
             */
            getRobotList(){
                if(!this.$common.global_robot_list){
                    let params = {
                        // channel_name: this.test_channel_name,
                        channel_name: this.$store.state.username,
                    };

                    this.$getRobotByChannelname(params, response=>{
                        if(response && response.code == 200){
                            this.$common.global_robot_list = response.data.list;
                            if(this.$common.global_robot_list[0].public_send_status === "open"){
                                this.switch_checked = true;
                            }else if(this.$common.global_robot_list[0].public_send_status === "close"){
                                this.switch_checked = false;
                            }
                        }
                    })
                }else{
                    if(this.$common.global_robot_list[0].public_send_status === "open"){
                        this.switch_checked = true;
                    }else if(this.$common.global_robot_list[0].public_send_status === "close"){
                        this.switch_checked = false;
                    }
                }
            },

            initAllRobotSkuList(){
                let list = this.WpJoinRobotListMark.all_robot_sku_list;

                let _sku_list_no_pushed = [];
                let _sku_list_pushed = [];
                for(let i = 0; i < list.length; i++){
                    // if(i === 0) {
                    //     list[i].task_status = 1;
                    // }

                    let content = list[i].message_list[1].msgContent;
                    let _skuName = content.substring(0, content.indexOf('\n'));

                    this.all_sku_list.push({
                        sku_img: list[i].message_list[0].msgContent,
                        sku_name: _skuName,
                        id: list[i].id,
                        sku_id: list[i].sku_id,
                        send_time: list[i].send_time
                    });

                    if(list[i].task_status === 0){
                        //未推送
                        _sku_list_no_pushed.push({
                            sku_img: list[i].message_list[0].msgContent,
                            sku_name: _skuName,
                            id: list[i].id,
                            sku_id: list[i].sku_id,
                            send_time: list[i].send_time
                        });
                    }

                    if(list[i].task_status === 1){
                        //已推送
                        _sku_list_pushed.push({
                            sku_img: list[i].message_list[0].msgContent,
                            sku_name: _skuName,
                            id: list[i].id,
                            sku_id: list[i].sku_id,
                            send_time: list[i].send_time
                        });
                    }
                }

                this.sku_list_no_pushed = _sku_list_no_pushed;
                this.sku_list_pushed = _sku_list_pushed;

                // this.temp_sku_list_no_pushed_length = this.sku_list_no_pushed.length;
            },
            /**
             * 清除选品清单列表中的所有商品
             */
            removeAllSelectSku() {

            },

            /**
             * 清除选品清单列表中的某一个商品
             */
            removeSelectSku(index) {

                this.moveOutRobot(index);
            },

            /**
             * 移出助理（即删除助理发品列表中当前商品对应的数据）
             */
            moveOutRobot(index){
                if(this.sku_list_no_pushed){
                    let sid = this.sku_list_no_pushed[index].id;
                    let params = {
                        id: sid,
                    }
                    this.$deleteDataFromRobot(params, response=>{

                        if(response && response.code === 200){
                            if(response.data && response.data.result && response.data.result === 'DELETED'){
                                //删除成功
                                this.join_robot_status = true;
                                Toast.success({
                                    duration: 1000,
                                    message:"移出成功"
                                });

                                //变量中移除
                                this.sku_list_no_pushed.splice(index, 1);
                            }
                        }else{
                            Toast.success({
                                duration: 1000,
                                message:"移出失败"
                            });
                        }
                    })

                }

            },

            clickCloseIcon(){
                const toast = Toast.loading({
                    duration: 0, // 持续展示 toast
                    forbidClick: true,
                    message: '数据重载'
                });
                // setTimeout(()=>{
                //     toast.clear();
                //     this.show_robot_sku_list_model = false;
                // }, 1500)
                setTimeout(()=>{
                    //必须要进行完成列表的查询，以保证再次进入详情时，可正确判断各种状态
                    this.$getDataListFromRobot_All(data=>{
                        // this.$emit("getAllRobatSkuData", data)
                        toast.clear();
                        this.$emit("updataBadgeCountAndData", this.sku_list_no_pushed.length, data);
                        this.show_robot_sku_list_model = false;
                    })
                }, 1500);
            },

            /**
             * 选品清单界面关闭
             */
            selectListClose() {
                // if(this.temp_sku_list_no_pushed_length !== -1 && this.temp_sku_list_no_pushed_length !== this.sku_list_no_pushed.length){
                //     this.$emit("updataJoinRobotButtonStatus");
                // }
                this.releaseSelectData();
            },


            releaseSelectData() {
                this.all_sku_list = [];
                // this.sku_list_no_pushed = [];
                // this.sku_list_pushed = [];
            },

            clearSelectSkuInfoData() {
                // this.WpJoinRobotListMark.robot_all_sku_list = [];
            },

            // changeSwitch(status){
            //     this.$log(status)
            //     if(status){
            //         this.changeRobotOnOff("open")
            //     }else{
            //         this.changeRobotOnOff("close")
            //     }
            // },
            //
            // changeRobotOnOff(send_status){
            //     let robot_list = this.$common.global_robot_list;
            //     if(robot_list){
            //         this.sendRobotStatus(robot_list, send_status)
            //     }
            // },
            //
            // sendRobotStatus(robot_list, status){
            //     let params = {
            //         robot_id: robot_list[0].vcRobotSerialNo,
            //         room_id: robot_list[0].vcChatRoomSerialNo,
            //         send_status: status
            //     };
            //     this.$sendRobotStatus(params, response=>{
            //         this.$log(response)
            //     })
            // },
        }
    }
</script>

<style scoped>
    .select_skuName_div {
        font-size: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        margin-left: 10px;
    }

</style>